export default "__VITE_ASSET__CXQ3$lvs__"